// extracted by mini-css-extract-plugin
module.exports = {"inputField":"TextInput_inputField__3XUYT","inputArea":"TextInput_inputArea__2AAl6"};